/**
 * The asset register's strings (piece 28), kept beside the register and spread
 * into the one lookup in `strings.ts`, so `t()` stays the only way a screen
 * reads text. 🔨 This file imports nothing, because the lookup imports it.
 */
export const ASSET_STRINGS = {
  'asset.title': 'Assets',
  'jobs.checkPMSchedules.label': 'Generate maintenance work orders',
  'jobs.checkPMSchedules.purpose': 'Raises one Draft Work Order for each maintenance schedule whose calendar interval or meter reading has come due since it last ran.',
  'whatsNew.area.assets': 'Assets',
  'asset.subtitle': 'The equipment and tools we own; a customer’s assets stand on their site',
  'asset.treeLabel': 'Asset tree',
  'asset.new': '+ New Asset',
  'asset.empty': 'No assets yet. + New asset starts the register, and a won Deal’s parts list fills it.',
  'asset.crumbSeparator': '›',
  'asset.narrowed': 'Showing the assets this company owns:',
  'asset.showAll': 'Show every asset',
  'asset.needsDepreciation.narrowed': 'Showing the assets whose depreciation is still to be set. Open one and add its schedule under Depreciation.',
  'asset.needsDepreciation.empty': 'No asset is waiting for its depreciation.',
  'asset.readOnly': 'You can read the register but not change it.',
  'asset.readOnly.what': 'the asset register',
  'asset.notFound': 'This asset is not in the register. It may have been removed.',
  'asset.type.assetGroup': 'System',
  'asset.type.functionGrouping': 'Function',
  'asset.type.componentGrouping': 'Assembly',
  'asset.type.component': 'Component',
  'asset.own': 'Ours',
  'asset.disposed': 'Disposed',
  // Decisions 12560 to 12562 (T3808): the drill-down tiles, the plant board, the status glyph and the picture-led page.
  'asset.status.fault': 'Fault',
  'asset.status.maintenance': 'Maintenance Due',
  'asset.status.workOrder': 'Open Work Order',
  'asset.status.disposed': 'Disposed',
  'asset.status.none': 'Fine',
  'asset.view.legend': 'View',
  'asset.view.tiles': 'Tiles',
  'asset.view.board': 'Board',
  'asset.view.list': 'List',
  'asset.list.label': 'Parts in working order',
  'asset.list.hint': 'Drag a part along the list to set its working order. The arrows on the board stay as they are.',
  'asset.list.readHint': 'The parts in their working order. The arrows stand on the board.',
  'asset.list.empty': 'No parts stand inside this Function yet.',
  'asset.view.pick': 'Pick an asset to see its page.',
  'asset.tiles.search': 'Search Equipment',
  'asset.tiles.searchHint': 'Name, tag or serial number',
  'asset.tiles.crumbs': 'Levels',
  'asset.tiles.top': 'Top Level',
  'asset.tiles.levelEmpty': 'Nothing stands beneath this one yet.',
  'asset.tiles.noMatch': 'Nothing in this register matches the search.',
  'asset.tiles.inside': '{count} inside',
  'asset.tiles.insideLabel': '{inside}, the worst of them {status}',
  'asset.tiles.partsOne': '1 part',
  'asset.tiles.parts': '{count} parts',
  'asset.tiles.matchesUnder': 'Matches under {name}',
  'asset.board.label': 'Plant Board',
  'asset.board.hint': 'Drag a card to place it, or drag the dot on its edge onto another card to link them. Double-click a card to open what stands beneath it.',
  'asset.board.readHint': 'Double-click a card to open what stands beneath it.',
  'asset.board.linkFrom': 'Link {name} to another card',
  'asset.board.unlink': 'Remove the arrow from {from} to {to}',
  'asset.board.empty': 'Nothing stands on this level yet.',
  'asset.board.fit': 'Fit Board',
  'asset.board.expanded': 'Expanded Cards',
  'asset.board.portHint': 'Drag a port onto the next Function’s port, or a part onto one of this Function’s ports.',
  'asset.port.in': 'In',
  'asset.port.out': 'Out',
  'asset.port.inNumber': 'In {number}',
  'asset.port.outNumber': 'Out {number}',
  'asset.port.handle': '{direction} port {port} of {name}',
  'asset.port.tile': 'Ports',
  'asset.port.none': 'No ports yet. A port is where an arrow crosses this Function’s edge.',
  'asset.port.add': '+ Add Port',
  'asset.port.addTitle': 'Add a Port',
  'asset.port.direction': 'Direction',
  'asset.port.name': 'Name',
  'asset.port.nameHint': 'Optional, such as Infeed; with none it reads by its direction and place.',
  'asset.port.remove': 'Remove Port',
  'asset.port.removeTitle': 'Remove this port?',
  'asset.port.removeBody': 'Its arrows go with it, on this Function’s board and on its parent’s.',
  'asset.port.removed': 'The port was removed.',
  'asset.reading.at': '{value} at {time}',
  'asset.band.label': 'Status',
  'asset.band.feed': 'Plant feed {state}',
  'asset.band.nextDue': 'Next maintenance {date}',
  'asset.band.noSchedule': 'No maintenance scheduled',
  'asset.tile.live': 'Live',
  'asset.live.none': 'No reading has come in from the plant feed for this asset.',
  'asset.live.lastRead': 'Last read {when}',
  'asset.tile.faults': 'Faults',
  'asset.faults.none': 'No faults recorded on this asset.',
  'asset.faults.open': 'Open',
  'asset.faults.cleared': 'Cleared',
  'asset.faults.since': 'Since {when}',
  'asset.faults.times': '{count} times',
  'asset.panel.close': 'Close',
  'asset.edit': 'Edit',
  'asset.move': 'Move',
  'asset.addBeneath': '+ Add Beneath',
  'asset.remove': 'Remove',
  'asset.image.title': 'Asset Image',
  'asset.image.set': 'Set Image',
  'asset.image.replace': 'Replace Image',
  'asset.image.remove': 'Remove Image',
  'asset.image.removeTitle': 'Remove this image?',
  'asset.image.removeBody': 'The image comes off the asset and its file goes to the trash.',
  'asset.image.alt': 'Asset image',
  'asset.template.saveAs': 'Save as Template',
  'asset.template.newFrom': 'New from Template',
  'asset.template.library': 'Asset Templates',
  'asset.template.title': 'Asset Templates',
  'asset.template.subtitle': 'Asset trees saved once and built again beneath a site or an asset',
  'asset.template.saveTitle': 'Save as Template',
  'asset.template.saveHint': 'The template keeps this asset and everything beneath it: each level, name and order, a component’s own attributes, and its maintenance schedules. It never keeps custody, history, serial numbers, tags, files, pictures, meter readings, the owner or Work Orders.',
  'asset.template.name': 'Template name',
  'asset.template.description': 'Description',
  'asset.template.saved': 'The template is saved. New From Template builds it again.',
  'asset.template.buildTitle': 'New from Template',
  'asset.template.pick': 'Template',
  'asset.template.pickEntity': 'template',
  'asset.template.pickFirst': 'Choose a template before building.',
  'asset.template.rootName': 'Name of the new top asset',
  'asset.template.buildHint': 'Every asset in the template is built beneath this one, with its attributes and maintenance schedules. A calendar schedule counts from today.',
  'asset.template.buildAt': 'Built at',
  'asset.template.buildBeneath': 'Built beneath',
  'asset.template.build': 'Build',
  'asset.template.nodes': 'assets',
  'asset.template.node': 'asset',
  'asset.template.savedBy': 'saved by',
  'asset.template.active': 'Active',
  'asset.template.retired': 'Retired',
  'asset.template.rename': 'Rename',
  'asset.template.renameTitle': 'Rename Template',
  'asset.template.retire': 'Retire',
  'asset.template.retireTitle': 'Retire this template?',
  'asset.template.retireBody': 'A retired template builds nothing from now on. It stays on this page for the record, and the assets already built from it are not touched.',
  'asset.template.empty': 'No templates yet. Save as Template on an asset’s page keeps it and everything beneath it.',
  'asset.template.back': 'Back to Assets',
  'asset.template.readOnly': 'You can read the templates but not change them.',
  'asset.template.readOnly.what': 'the asset templates',
  'asset.removeConfirm': 'Remove this asset from the register? Its id is never given to another asset, and a node with any history is disposed of instead.',
  'asset.saved': 'Saved.',
  'asset.field.name': 'Name',
  'asset.field.type': 'Level',
  'asset.field.parent': 'Beneath',
  'asset.field.top': 'The top of the register',
  'asset.field.position': 'Position among its siblings',
  'asset.field.site': 'Installed at',
  'asset.field.noSite': 'Not installed: in stores or on a truck',
  'asset.site.none': 'No site',
  'asset.site.tileEmpty': 'No assets stand at this site yet.',
  'asset.site.noneMeta': 'In stores or on a truck',
  'asset.site.countOne': '1 asset',
  'asset.site.countMany': '{count} assets',
  'asset.site.newHere': '+ New',
  'asset.site.inherited': 'Its site comes from the top of its tree:',
  'asset.site.inheritedShort': 'from the top of its tree',
  'asset.site.moveHint': 'At the top of the register a node carries its own site. Beneath another node it takes that node’s site, and so does everything beneath it.',
  'asset.field.serial': 'Serial number',
  'asset.field.serialHint': 'The manufacturer’s serial, read off the equipment',
  'asset.field.tag': 'Asset tag',
  'asset.field.tagHint': 'The sticker we put on it',
  'asset.field.warranty': 'Warranty expires',
  'asset.field.acquiredOn': 'Acquired',
  'asset.field.acquisitionCost': 'Acquisition cost',
  'asset.field.owner': 'Owner',
  'asset.field.ownerHint': 'Only a node at the top of the register names its owner; the nodes beneath read it from above.',
  'asset.field.disposedOn': 'Disposed on',
  'asset.field.proceeds': 'Disposal proceeds',
  'asset.field.disposalReason': 'Why it was disposed of',
  'asset.field.sourceBill': 'Source bill',
  'asset.sourceBill.line': 'line',
  'asset.newTitle': 'New Asset',
  'asset.editTitle': 'Edit Asset',
  'asset.moveTitle': 'Move Asset',
  'asset.moveHint': 'Stack the parts the way they are built: pick the grouping this node sits beneath, or none for the top.',
  'asset.tile.general': 'General Information',
  'asset.tile.ownership': 'Ownership',
  'asset.tile.custody': 'Custody',
  'asset.tile.component': 'Catalog Part',
  'asset.tile.attributes': 'Attributes',
  'asset.tile.maintenance': 'Maintenance',
  'asset.tile.depreciation': 'Depreciation',
  'asset.tile.workOrders': 'Work Order History',
  'asset.tile.serviceHistory': 'Service History',
  'asset.tile.notes': 'Notes',
  'asset.tile.files': 'Files',
  'asset.tile.openTree': 'Open the asset tree',
  'asset.tile.issued': 'Issued',
  'asset.tile.dueBack': 'due back',
  'asset.tile.returned': 'returned',
  'asset.tile.held': 'Held',
  'asset.tile.returnedPill': 'Returned',
  'asset.warranty.component': 'the part’s own warranty',
  'asset.warranty.asset': 'the asset’s warranty',
  'asset.warranty.none': 'None recorded',
  'asset.owner.none': 'No owner recorded',
  'asset.owner.inherited': 'read from the node above',
  'asset.owner.add': '+ Owner',
  'asset.owner.close': 'Close',
  'asset.owner.current': 'Current',
  'asset.owner.ended': 'Ended',
  'asset.owner.addTitle': 'Name the Owner',
  'asset.owner.closeTitle': 'Close Ownership',
  'asset.owner.from': 'Owned from',
  'asset.owner.until': 'Owned until',
  'asset.owner.company': 'Company',
  'asset.owner.companyEntity': 'Company',
  'asset.custody.issue': '+ Issue',
  'asset.custody.takeBack': 'Take back',
  'asset.custody.issueTitle': 'Issue This Asset',
  'asset.custody.returnTitle': 'Take This Asset Back',
  'asset.custody.holder': 'Issued to',
  'asset.custody.issuedBy': 'Handed out by',
  'asset.custody.issuedOn': 'Issued on',
  'asset.custody.expectedReturn': 'Expected back',
  'asset.custody.returnedOn': 'Returned on',
  'asset.custody.returnedTo': 'Taken back by',
  'asset.custody.condition': 'Condition at return',
  'asset.custody.conditionHint': 'Written now, at the hand-back, and at no other time.',
  'asset.custody.personEntity': 'Person',
  'asset.custody.none': 'Nobody has held this asset.',
  'asset.custody.issuedByLine': 'handed out by',
  'asset.custody.returnedToLine': 'taken back by',
  // 🔒 The attributes left at Visibility Work Orders, drawn on the Work Order line naming the asset (piece 28; T2367).
  'asset.workOrderLine.attributes': 'Asset Attributes',
  // 🔒 The Load-Out Check, asked on the Work Order page at dispatch (decisions 0151 and 9140; T2367).
  'asset.loadOut.title': 'Load-Out Check',
  'asset.loadOut.hint': 'Asked as the crew leaves the shop. Each yes is recorded against the person who said it; nothing here holds the dispatch, which is already sent.',
  'asset.loadOut.none': 'The site and the job’s checklists ask for no equipment to bring.',
  'asset.loadOut.shared': 'Shared, once for the visit',
  'asset.loadOut.unnamed': 'A worker no longer on the job',
  'asset.loadOut.acknowledged': 'Acknowledged',
  'asset.loadOut.acknowledge': 'Acknowledge',
  'asset.loadOut.instrument': 'Instrument going on the truck',
  'asset.loadOut.instrumentEntity': 'Instrument',
  'asset.loadOut.pickFirst': 'Pick the instrument first; saying yes issues it until the visit’s day.',
  'asset.component.link': 'Link a catalog part',
  'asset.component.change': 'Change part',
  'asset.component.item': 'Catalog part',
  'asset.component.itemEntity': 'Item',
  'asset.component.linkTitle': 'Linked Item',
  'asset.component.linkHint': 'Changing the part replaces the link and the locked attributes with the new part’s own.',
  'asset.component.ownWarranty': 'This Part’s Own Warranty Expires',
  'asset.component.none': 'Not linked to a catalog part yet.',
  'asset.component.linked': 'Linked',
  'asset.component.onlyComponent': 'Only a Component links to a catalog part or carries attributes of its own.',
  'asset.attribute.add': '+ Add Attribute',
  'asset.attribute.locked': 'Set on the catalog part; edit the Item to change it',
  'asset.attribute.remove': 'Remove attribute',
  'asset.attribute.removeMark': '×',
  'asset.attribute.editLabel': 'Edit Attribute',
  'asset.attribute.none': 'No attributes yet.',
  'asset.attribute.held': 'A change order waiting for approval affects this component, so its values hold until it resolves:',
  'asset.attribute.visibility.assetRecord': 'Asset record',
  'asset.attribute.visibility.workOrders': 'Work Orders',
  'asset.attribute.visibility.reports': 'Reports',
  'asset.workOrders.none': 'No Work Order has named this component yet.',
  'asset.workOrders.readOnly': 'Read from the Work Orders that name this component; edit a Work Order to change its row.',
  'asset.schedule.add': '+ Schedule',
  'asset.schedule.title': 'Maintenance Schedule',
  'asset.schedule.editTitle': 'Edit Maintenance Schedule',
  'asset.schedule.name': 'Name',
  'asset.schedule.trigger': 'Triggered By',
  'asset.schedule.calendar': 'Calendar',
  'asset.schedule.meter': 'Meter',
  'asset.schedule.interval': 'Every (days)',
  'asset.schedule.startsOn': 'Counting from',
  'asset.schedule.startsOnHint': 'Usually the day the work was last done.',
  'asset.schedule.meterAttribute': 'Reading',
  'asset.schedule.meterThreshold': 'Due after a rise of',
  'asset.schedule.meterHint': 'The reading is the component’s own attribute of this kind, or its catalog part’s, in the attribute’s base unit.',
  'asset.schedule.template': 'Checklist template',
  'asset.schedule.active': 'Active',
  'asset.schedule.nextDue': 'Next due',
  'asset.schedule.lastDraft': 'Last Draft',
  'asset.schedule.lastDone': 'Last done',
  'asset.schedule.neverDone': 'not done yet',
  'asset.schedule.overdue': 'Overdue',
  'asset.history.none': 'No Work Order has named this asset or anything beneath it yet.',
  'asset.history.readOnly': 'Read from the Work Orders whose lines name this asset or anything beneath it; open a Work Order to change its row.',
  'asset.history.noTechnicians': 'No technician assigned',
  'asset.history.checklist': 'Checklist',
  'asset.history.checklistOf': 'of',
  'asset.history.checklistDone': 'done',
  'asset.history.noChecklist': 'No checklist',
  'asset.schedule.reading': 'reading now',
  'asset.schedule.noReading': 'no reading recorded',
  'asset.schedule.every': 'every',
  'asset.schedule.days': 'days',
  'asset.schedule.inactive': 'Paused',
  'asset.schedule.none': 'No maintenance scheduled.',
  'asset.schedule.runNow': 'Check schedules now',
  'asset.schedule.ran': 'Schedules checked',
  'asset.schedule.noTemplates': 'No checklist template exists yet; add one under Settings before scheduling maintenance.',
  'asset.depreciation.add': '+ Depreciation Schedule',
  'asset.depreciation.title': 'Depreciation Schedule',
  'asset.depreciation.method': 'Method',
  'asset.depreciation.straightLine': 'Straight line',
  'asset.depreciation.decliningBalance': 'Declining balance',
  'asset.depreciation.life': 'Useful life (months)',
  'asset.depreciation.salvage': 'Salvage value',
  'asset.depreciation.startDate': 'Starts',
  'asset.depreciation.assetAccount': 'Asset account',
  'asset.depreciation.expenseAccount': 'Expense account',
  'asset.depreciation.accumulatedAccount': 'Accumulated depreciation account',
  'asset.depreciation.accountEntity': 'Account',
  'asset.depreciation.none': 'Not capitalized: no depreciation schedule, which is fine for a hand tool.',
  'asset.depreciation.toSet': 'A Set Depreciation item is open for this asset. Add its schedule here and the item closes.',
  'asset.depreciation.monthly': 'first month',
  // 🔒 One month's depreciation posted as one Manual Journal, once (decision 9141; T2367).
  'asset.depreciation.post': 'Post Depreciation',
  'asset.depreciation.postTitle': 'Post a Month’s Depreciation',
  'asset.depreciation.postAct': 'Post',
  'asset.depreciation.schedule': 'Schedule',
  'asset.depreciation.months': 'months',
  'asset.depreciation.month': 'Month',
  'asset.depreciation.monthPosted': '{month} · posted',
  'asset.depreciation.noMonth': 'The schedule has no month to post yet; its first month has not ended.',
  'asset.depreciation.postHint': 'Posts one Manual Journal dated the month’s last day: the month’s depreciation to the expense account, credited to accumulated depreciation. A month already posted posts nothing again.',
  'asset.depreciation.postPreview': 'Debit {expense} and credit {accumulated} by {amount}.',
  'asset.depreciation.postedOne': 'Depreciation for {month} posted as {entry}.',
  'asset.depreciation.alreadyPosted': 'Depreciation for {month} already stands as {entry}; nothing new was posted.',
  'asset.depreciation.lastPosted': 'last posted {month}',
  'asset.notes.none': 'No notes yet.',
  'asset.files.upload': '↑ Upload',
  'asset.files.none': 'No files yet.',
  'asset.convert.title': 'Convert the Parts List to Assets',
  'asset.convert.subtitle': 'Every checked line becomes assets at the top of the register',
  'asset.convert.hint': 'Uncheck the lines that are not assets — consumables, fasteners, spare fuses. They stay on the bill of materials. The parts land at the top of the register with no parent; stack them afterwards.',
  'asset.convert.line': 'Part',
  'asset.convert.quantity': 'Quantity',
  'asset.convert.makes': 'Makes',
  'asset.convert.already': 'Already made',
  'asset.convert.bulk': 'one node for the whole quantity',
  'asset.convert.run': 'Convert Checked Lines',
  'asset.convert.done': 'Assets created',
  'asset.convert.nothing': 'This Deal’s bills of materials carry no Good to convert.',
  'asset.convert.notWon': 'The conversion runs on a won Deal.',
  'asset.convert.openAssets': 'Open the asset tree',
  'asset.depreciation.todo': 'Set depreciation for',
  'asset.convert.todo': 'Review the parts list and convert it to assets',
  // Decision 12504: the plant feed's nightly purge on the Scheduled jobs card.
  // Decisions 12502 and 12505: the two plant feed To-Dos' titles, followed by the site, the node and the fault.
  'asset.feed.alarmTodo': 'Check in with the site about a repeating plant fault',
  'asset.feed.noUnitNote': 'Read from the plant feed with no unit mapped; the base value is the raw reading.',
  'asset.feed.silentTodo': 'Check in with the site: its plant feed has gone quiet',
  'jobs.purgePlantFeed.label': 'Purge the plant feed',
  'jobs.purgePlantFeed.purpose': 'Deletes the plant feed’s readings, fault messages and cleared faults older than the days the feed keeps.',
} as const;
